<h2>Confirmation</h2>

<p>{{data.text}}</p>

<div class="btn_action">
  <button type="button" class="back" (click)="dialogRef.close(false)">Annuler</button>
  <button class="confirm" (click)="dialogRef.close(true)"> Confirmer</button>
</div>
